import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Input } from 'reactstrap';
import { PricingsModel } from 'franke-trough-dependencies';
import { formatPeriod } from 'src/app/Partials/Admin/Pricing/Pricings';

export const PeriodSelectionDropdown = ({ pricings, selectedPeriod, type, isDisabled, onChange, label }: any) => {
  return (
    <>
      <small><strong>{label}</strong></small>
      <Input
        className="form-control mt-2"
        type="select"
        name={'pricings_'+type}
        value={selectedPeriod}
        onChange={(event) => onChange(event, type)}
        disabled={isDisabled}
      >
        {pricings && pricings.result && pricings.result.map((pricing: PricingsModel) => {
          if (
            pricing.type !== type
            || (pricing.deleted && pricing.id !== selectedPeriod)
          ) { return; }

          return <option key={pricing.id} value={pricing.id}>{formatPeriod(pricing.dateFrom, pricing.dateUntil)}</option>
        })}
      </Input>
    </>
  )
}

export default PeriodSelectionDropdown;